var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitterIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Twitter",
    transform: "translate(-1328 -1072)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Surface",
    width: 44,
    height: 44,
    rx: 22,
    transform: "translate(1328 1072)",
    fill: "#03a9f4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11250",
    "data-name": "Group 11250",
    transform: "translate(951 513)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148115",
    "data-name": "Rectangle 148115",
    width: 24,
    height: 24,
    transform: "translate(387 569)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_142",
    "data-name": "Path 142",
    d: "M15.636,51.609c.011.155.011.31.011.464A10.093,10.093,0,0,1,5.485,62.236,10.094,10.094,0,0,1,0,60.633a7.388,7.388,0,0,0,.863.044A7.153,7.153,0,0,0,5.3,59.151a3.578,3.578,0,0,1-3.34-2.477,4.5,4.5,0,0,0,.675.055,3.778,3.778,0,0,0,.94-.122A3.572,3.572,0,0,1,.708,53.1v-.044a3.6,3.6,0,0,0,1.614.453,3.577,3.577,0,0,1-1.106-4.777,10.153,10.153,0,0,0,7.365,3.738,4.032,4.032,0,0,1-.088-.818,3.575,3.575,0,0,1,6.182-2.444,7.032,7.032,0,0,0,2.267-.863,3.562,3.562,0,0,1-1.57,1.968,7.161,7.161,0,0,0,2.057-.553,7.678,7.678,0,0,1-1.791,1.847Z",
    transform: "translate(390.286 525.918)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterIcon);
export default __webpack_public_path__ + "static/media/Twitter-icon.3503b1588d82b85b6b95e171be85fb48.svg";
export { ForwardRef as ReactComponent };